// TODO: Add more
export enum AccessManagementPermissionId {
  DEVICES_VIEW,
  DEVICES_EDIT,
}
